/* eslint-disable no-unused-vars */
/* eslint-disable sort-imports */
/* eslint-disable prettier/prettier */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import { Icon } from '@cochlear-design-system/foundation';

import PlacesAutocomplete from '../PlacesAutoComplete/PlacesAutocomplete.jsx';
import { geocodeByPlaceId } from '../PlacesAutoComplete/utils';
import {
  formatStreet,
  formatJP,
  formatKR,
} from '../utils/adaptiveForm/addressFormatter';

export const LocationSearchInputAddressInput = (props) => {
  const {
    mapToField,
    address,
    updateAddress,
    enableForm,
    searchCharLength,
    name,
    optionalText,
    hint,
    promptText,
    promptMobile,
    country,
    label,
    loadingText,
    types,
    addressNotFound,
    formik,
    error,
    setFocus,
    addressAPIState,
    disabled,
    isFilled,
    countryStates,
    isPo,
  } = props;
  const [addressText, setAddressText] = useState(
    address.addressText || '',
  );
  const [isSelectAddress, setSelectAddress] = useState(false);
  const {
    addressAPIStateTypeId = 'administrative_area_level_1', // set default
    addressAPIStateName = 'short_name', // set default
  } = addressAPIState;

  const manualEntryString = `${addressNotFound.text} <span>${addressNotFound.button}</span>`;

  const handleChange = (addr) => {
    if (addr === manualEntryString) {
      setAddressText('');

      return false;
    }

    setAddressText(addr);
    setSelectAddress(false);

    return false;
  };

  useEffect(() => {
    if (mapToField === 'city') setAddressText(address.city);
    // eslint-disable-next-line
  }, [address.city]);

  const handleSelect = async (addr, placeId) => {
    if (addr === manualEntryString) {
      enableForm();
      setAddressText('');

      return false;
    }
    const ls = await geocodeByPlaceId(placeId);
    const x = ls[0];

    const countryCode = country.toLowerCase();
    const addressComponents = x.address_components;

    // street number
    const streetNumberSelector = addressComponents.filter((y) =>
      y.types.includes('street_number'),
    );
    const streetNumber =
      streetNumberSelector.length > 0
        ? streetNumberSelector[0].long_name
        : '';

    // street name
    const streetNameSelector = addressComponents.filter((y) =>
      y.types.includes('route'),
    );
    const streetName =
      streetNameSelector.length > 0
        ? streetNameSelector[0].long_name
        : '';

    // city
    const cityLocalitySelector = addressComponents.filter((y) =>
      y.types.includes('locality'),
    );
    const cityAdminLvl1Selector = addressComponents.filter((y) =>
      y.types.includes('administrative_area_level_1'),
    );
    const citySublocalitySelector = addressComponents.filter((y) =>
      y.types.includes('sublocality'),
    );
    const citySublocalityLvl1Selector = addressComponents.filter(
      (y) => y.types.includes('sublocality_level_1'),
    );
    const citySublocalityLvl4Selector = addressComponents.filter(
      (y) => y.types.includes('sublocality_level_4'),
    );
    const cityPostalTownSelector = addressComponents.filter((y) =>
      y.types.includes('postal_town'),
    );
    const cityNeighborhoodSelector = addressComponents.filter((y) =>
      y.types.includes('neighborhood'),
    );

    const getCity = (cntryCode) => {
      switch (cntryCode) {
        case 'kr':
          if (
            cityLocalitySelector.length > 0 &&
            cityAdminLvl1Selector.length > 0 &&
            (citySublocalityLvl1Selector.length <= 0 ||
              citySublocalityLvl4Selector.length <= 0)
          )
            return cityAdminLvl1Selector[0].long_name;
          if (cityLocalitySelector.length > 0)
            return cityLocalitySelector[0].long_name;
          if (cityAdminLvl1Selector.length > 0)
            return cityAdminLvl1Selector[0].long_name;
          if (citySublocalitySelector.length > 0)
            return citySublocalitySelector[0].long_name;
          if (cityPostalTownSelector.length > 0)
            return cityPostalTownSelector[0].long_name;
          if (cityNeighborhoodSelector.length > 0)
            return cityNeighborhoodSelector[0].long_name;

          return '';
        default:
          if (cityLocalitySelector.length > 0)
            return cityLocalitySelector[0].long_name;
          if (citySublocalitySelector.length > 0)
            return citySublocalitySelector[0].long_name;
          if (cityPostalTownSelector.length > 0)
            return cityPostalTownSelector[0].long_name;
          if (cityNeighborhoodSelector.length > 0)
            return cityNeighborhoodSelector[0].long_name;

          return '';
      }
    };
    const city = getCity(countryCode);

    // state
    const stateSelector = addressComponents.filter(
      (y) => y.types.includes(addressAPIStateTypeId || undefined), // default to 'administrative_area_level_1'
    );
    const state =
      stateSelector.length > 0
        ? stateSelector[0][addressAPIStateName || undefined] // defaults to 'short_name'
        : '';

    // Extract postcode and optional suffix
    const postcodeComponent = addressComponents.find((c) =>
      c.types.includes('postal_code'),
    );
    const suffixComponent = addressComponents.find((c) =>
      c.types.includes('postal_code_suffix'),
    );

    const postcode = postcodeComponent
      ? postcodeComponent.long_name
      : '';
    const postcodeSuffix = suffixComponent
      ? suffixComponent.long_name
      : '';

    const fullPostcode =
      countryCode === 'us' && postcode && postcodeSuffix
        ? `${postcode}-${postcodeSuffix}` // For the US, the format if a suffix exists is to append using a hyphen
        : postcode + postcodeSuffix; // Otherwise, if a suffix exists, just add it to the postcode (eg, Argentina)

    // how to display street 1
    const getStreet1 = (cntryCode) => {
      switch (cntryCode) {
        case 'jp':
          return formatJP(addressComponents, city, fullPostcode);
        case 'kr':
          return formatKR(addressComponents, city, fullPostcode);
        default:
          return formatStreet(streetNumber, streetName, cntryCode);
      }
    };
    const street1 = getStreet1(countryCode);

    updateAddress(
      {
        ...address,
        addressText: addr,
        street: street1,
        city,
        state,
        postcode: fullPostcode,
        isPO: isPo,
      },
      formik,
    );

    setSelectAddress(true);
    setAddressText(addr);

    return false;
  };

  const searchOptions = {
    types,
    componentRestrictions: { country },
  };

  const chars = searchCharLength - 2;
  // Log error status and clear dropdown when Google Maps API returns an error.
  const onError = (status, clearSuggestions) => {
    // Log the error status using a custom error handler or monitoring tool
    console.error(
      'Google Maps API returned error with status: ',
      status,
    );
    clearSuggestions();
    // enableForm();
  };

  // placeholder text shown on the typeahead.
  // We have a shortened value if viewed on mobile
  const prompt = window.matchMedia('(min-width: 768px)').matches
    ? promptText
    : promptMobile;

  function addEnableListButton(suggestions) {
    if (suggestions.length > 0) {
      if (
        suggestions[suggestions.length - 1].placeId !==
        'address-not-found'
      ) {
        suggestions.push({
          id: undefined,
          description: manualEntryString,
          placeId: 'address-not-found',
          index: suggestions.length,
          active: false,
        });

        return suggestions;
      }
    }

    return null;
  }

  // Add manual option when suggestionsList data  from google is null
  function addManualListButton(suggestions) {
    suggestions.push({
      id: undefined,
      description: manualEntryString,
      placeId: 'address-not-found',
      index: suggestions.length,
      active: false,
    });

    return suggestions;
  }

  // Control if show the SuggestionsList data
  const [showList, setShowList] = useState(true);
  const hideList = () => {
    setShowList(false);
  };

  // Get if stored a selected google address.
  const [isFill, setIsFilled] = useState(isFilled);
  const [ispo, setIspo] = useState(isPo);

  // Get if user edit search input already
  const [hasEditSearch, setHasEditSearch] = useState(false);

  // When has stored google address so filled the search Input
  useEffect(() => {
    if (isFill && !ispo && !hasEditSearch) {
      const cState = countryStates?.filter((s) => {
        return (
          s.label === address?.state || s.value === address?.state
        );
      });
      setAddressText(
        `${address?.street?.replace(/\r\n/g, ', ')}, ${
          address?.city
        }, ${cState[0] ? `${cState[0]?.value}, ` : ''}${country}`,
      );
      updateAddress(
        {
          ...address,
          street: `${address.street}`,
          city: `${address.city}`,
          state: `${address.state}`,
          postcode: `${address.postcode}`,
          isPO: isPo,
        },
        formik,
      );
      hideList();
    }
  }, [isFilled]);

  // For empty address input
  // when select a google address already , and check the  isPO checkbox to make manual typing,
  // But user click the checkbox again, update the checkbox isPO 's value back to false.
  // So the code below used for clean the manual address data
  // Get the typeing string value
  const [currString, setCurrString] = useState('');
  useEffect(() => {
    if (currString.length > 0 && !isPo && !isFill) {
      updateAddress(
        {
          ...address,
          street: `${address.street}`,
          city: `${address.city}`,
          state: `${address.state}`,
          postcode: `${address.postcode}`,
          isPO: isPo,
        },
        formik,
      );
      hideList();
    }
  }, [isPo]);

  useEffect(() => {
    if (!(isPo === ispo) || ispo) {
      updateAddress(
        {
          ...address,
          isPO: isPo,
        },
        formik,
      );
      hideList();
    }
  }, [isPo]);

  // For has address data and isPo is true,
  // when update the checkbox isPO 's value to false, clean the address data

  useEffect(() => {
    if (currString.length === 0 && !isPo && ispo) {
      updateAddress(
        {
          ...address,
          street: ``,
          city: ``,
          state: ``,
          postcode: ``,
          isPO: isPo,
        },
        formik,
      );
      hideList();
    }
  }, [isPo]);

  const handleInputChange = (curr) => {
    setHasEditSearch(true);
    if (curr.target.value.length === 0) {
      setAddressText(``);
      updateAddress(
        {
          ...address,
          street: ``,
          city: ``,
          state: ``,
          postcode: ``,
          isPO: isPo,
        },
        formik,
      );
    }
    setCurrString(curr.target.value);
    setShowList(true);
  };

  const SuggestionsList = ({
    getInputProps,
    getSuggestionItemProps,
    suggestions,
    loading,
  }) => {
    // add custom list option
    addEnableListButton(suggestions);
    if (suggestions.length <= 0) {
      addManualListButton(suggestions);
    }

    const cssComponentClass = 'ccl__form-input';
    const cssTextClass = 'ccl__text';

    const formInputErrorCss = error
      ? `${cssComponentClass}--has-error`
      : '';

    // Darken the matched string color
    const getCurrString = (str) => {
      const indexOfCurr = str
        .toLowerCase()
        .indexOf(currString.toLowerCase());

      if (indexOfCurr > -1) {
        return `${str.slice(0, indexOfCurr)}<b>${str.slice(
          indexOfCurr,
          currString.length,
        )}</b>${str.slice(indexOfCurr + currString.length)} `;
      }
      return str;
    };

    const isError = !!error;

    let iconColor = '';
    if (isError) {
      iconColor = 'error';
    } else if (disabled) {
      iconColor = 'disabled';
    }

    return (
      <div
        className={`ccl__form-input ccl__form-input__typeahead ${formInputErrorCss}`}
      >
        <label
          className={`${cssComponentClass}__label ${cssTextClass} ${cssTextClass}--body-text-bold ${
            label ? '' : 'is-sr-only' // if there isnt a label, apply the sr only class
          }`}
          htmlFor={name}
        >
          {label || prompt}
          {optionalText && (
            <span
              className={`${cssComponentClass}__label__optional ${cssTextClass} ${cssTextClass}--small-body-text-italic`}
            >
              {`(${optionalText})`}
            </span>
          )}
        </label>

        {hint && (
          <p
            className={`${cssComponentClass}__hint ${cssTextClass} ${cssTextClass}--informative-text`}
          >
            {hint}
          </p>
        )}

        <div className="ccl__field-control ccl__field-control--has-icon ccl__form-input--left">
          <Icon type="search" color={iconColor} />
          <input
            key={isError}
            {...getInputProps({
              placeholder: prompt,
              className: `location-search-input ccl__field-control__input ccl__text ccl__text--body-text ${
                addressText && isSelectAddress
                  ? 'location-search-input__blod'
                  : ''
              }`,
            })}
            id={name}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus={!!setFocus}
            disabled={disabled}
            onInput={handleInputChange}
            onBlur={hideList}
          />
        </div>

        {suggestions.length > 0 &&
          addressText &&
          !isSelectAddress && (
            <div
              aria-live="polite"
              className={`address__typeahead  ${
                !showList ? 'address__typeahead__hide' : ''
              }`}
              data-nw-addresslookup
            >
              <ul className="address__list">
                {loading && (
                  <li className="address__list__item">
                    <span className="address__list__item__button">
                      {loadingText}
                    </span>
                  </li>
                )}
                {suggestions.map((suggestion) => {
                  const className = suggestion.active
                    ? 'address__list__item address__list__item--active '
                    : 'address__list__item';

                  return (
                    <li
                      {...getSuggestionItemProps(suggestion, {
                        className,
                      })}
                      key={suggestion.placeId}
                    >
                      <button
                        type="button"
                        className="address__list__item__button"
                        data-nw-addresslookup-option={
                          suggestion.placeId
                        }
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            suggestion.placeId !== 'address-not-found'
                              ? getCurrString(suggestion.description)
                              : suggestion.description,
                          ),
                        }}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

        {error && (
          <p className="ccl__form-input__error-message ccl__text ccl__text--error-small-text">
            {error}
          </p>
        )}
      </div>
    );
  };

  return (
    <>
      <PlacesAutocomplete
        value={addressText}
        searchOptions={searchOptions}
        onChange={handleChange}
        shouldFetchSuggestions={addressText.length > chars}
        onSelect={handleSelect}
        onError={onError}
      >
        {SuggestionsList}
      </PlacesAutocomplete>
    </>
  );
};
